import { SaleRegisterReportsReducer } from "../reducer/SaleRegisterReportsReducer";

export const reducer = SaleRegisterReportsReducer;